
import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import CreatableSelect from "react-select/creatable";
import axios from "../../API/axios";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { debounce } from "lodash";
import { Form, Input, } from "reactstrap";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import Flatpickr from 'react-flatpickr';
import { resume } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CCVEducationUpdate = ({
    resumeId,
    getUserCcv,
    educationData,
    showEducationUpdate,
    setShowEducationUpdate,
    handleUpdateEducationClose,
}) => {
    console.log("educationData==>", getUserCcv);
    const [display, setDisplay] = useState(false);
    const sessionId = localStorage.getItem("sessionId");
    const UserCcv = localStorage.getItem("UserCcv");

        const { t } = useTranslation();
        const language = localStorage.getItem("Lang");
          const [showInputInsteadOfDropdown, setShowInputInsteadOfDropdown] = useState(false);
        const [showInputInsteadOfDropdownD, setShowInputInsteadOfDropdownD] = useState(false);
        const [showInputInsteadOfDropdownG, setShowInputInsteadOfDropdownG] = useState(false);
        const [showInputInsteadOfDropdownA, setShowInputInsteadOfDropdownA] = useState(false);
  
    const [startDate, setStartDate] = useState(null);
    // const [startDate, setStartDate] = useState(() => {
    //   if (educationData?.startMonth && educationData?.startYear) {
    //     return new Date(educationData.startYear, educationData.startMonth - 1);
    //   }
    //   return '';
    // });
    const [endDate, setEndDate] = useState(null);
    const isEducationDateRangeInvalid =
        Boolean(startDate) &&
        Boolean(endDate) &&
        moment(endDate).isBefore(moment(startDate), "day");
    // const [endDate, setEndDate] = useState(() => {
    //   if (educationData?.endMonth && educationData?.endYear) {
    //     return new Date(educationData.endYear, educationData.endMonth - 1);
    //   }
    //   return '';
    // });

    const [field, setField] = useState("");
    const [grade, setGrade] = useState("");
    const [degree, setDegree] = useState("");
    const [activities, setActivities] = useState("");
    const [present, setPresent] = useState(false);
    const [description, setDescription] = useState("");
    const [valueIns, setValueIns] = useState(null);

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const addOptionsIns = () => {
        axios
            .get(
                `Master/GetAllInstitutionsDDL?search=${typedIns}&pageNumber=${pageIns
                }&pageSize=100&DeviceType=Web&LangKey=${language}`
            )
            .then((response) => {
                const data = response.data.responseData.list.map((item) => ({
                    value: item.uiDno,
                    label: item.name,
                    isOrgVrfd: item.isVerified,
                    isOrgRgd: item.isRgstrd,

                }));
                setPageIns((prevPage) => prevPage + 1);
                setOptionsIns((prevOptions) => [...prevOptions, ...data]);
                setTotalPagesIns(response.data.responseData.paging.totalPages);
            })
            .catch((error) => {
                console.log(error);
            });
    };
     const mappedActivities = Array.isArray(activities)
  ? activities
      .filter((item) => item && item.value) // filter out any null/undefined
      .map((item) => item.value)
      .join(' , ')
  : '';

    const [getOrgInsTId, setGenOrgInstId] = useState('');
    const UpdateEducation = async (event) => {
        setDisplay(true);
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            cityId: cityId,
            startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
            endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
            isPresent: present,
            locationId: null,
            startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
            endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
            description: description,
            institutionUid: valueIns === null ? JSON.stringify(getOrgInsTId) : valueIns,
            field: field,
            degree: degree,
            grade: grade,
            activities: mappedActivities,
            rsmEductnId: educationData?.rsmEductnId,
            rsmId: resumeId
        };
        const data1 = {
            deviceType: "Web",
            sessionId: sessionId,
            cityId: cityId,
            startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
            endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
            isPresent: present,
            locationId: null,
            startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
            endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
            description: description,
            institutionUid: valueIns === null ? JSON.stringify(getOrgInsTId) : valueIns,
            field: field,
            degree: degree,
            grade: grade,
            activities: mappedActivities,
            userEductnId: educationData?.usrEductnId,
            langKey: language === "en" ? "" : language,
            isSynced: sync
        };
        if (!cityId || !field || !degree || !startDate || (!present && !endDate)) {
            setErrorToastMessage(t("modals.Please fill all the required fields"));
            setShowErrorToast(true);
            return;
        }

        if (!present && isEducationDateRangeInvalid) {
            setErrorToastMessage("End date cannot be earlier than start date.");
            setShowErrorToast(true);
            return;
        }

        const apiUrl = educationData.isSyncedWithUserData
            ? `UserData/UpdateEducationInfo`
            : `ResumeData/UpdateRsmEducationInfo`;

        const payload = educationData.isSyncedWithUserData ? data1 : data;
        try {
            await axios.put(apiUrl, payload).then((resData) => {
                setToastMessage(resData.data.message);
                setShowToast(true);
                getUserCcv();
                setShowEducationUpdate(false);
            });
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    const [specData, setSpecData] = useState([]);
    const [specId, setSpecId] = useState(null);
    const getSpecialization = () => {

        axios
            .get(`Master/GetSpecializationsDDL?LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const data = res.map((item) => ({
                    value: item.spclznId,
                    label: item.name,
                }));
                setSpecData(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        getSpecialization();
    }, []);

    const getUserInfoList = () => {
        const userInfoData = {
            deviceType: "Web",
            sessionId: sessionId,
        };
        axios.get(`UserData/GetUserEducationInfoList`, userInfoData)
            .then((response) => {
                const res = response.data.responseData;
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const [qualiData, setQualiData] = useState([]);
    const [qualiId, setQualiId] = useState(null);
    const getQualification = () => {
        axios
            .get(`Master/GetQualificationsDDL?LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const data = res.map((item) => ({
                    value: item.qlfctnId,
                    label: item.name,
                }));
                setQualiData(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        getQualification();
    }, []);

    const [cityData, setCityData] = useState([]);
    const [cityId, setCityId] = useState(null);
    const [citySearch, setCitySearch] = useState("");
    const getCity = () => {
        axios
            .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const data = res.map((item) => ({
                    value: item.cityId,
                    label: item.cityName,
                }));
                setCityData(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        if (citySearch) {
            getCity();
        }
    }, [citySearch]);

    const handleOpenIns = () => {
        setPageIns(1);
    };


    const handleChangeIns = (valueIns) => {
        if (valueIns === null) {
            setValueIns(null);
        } else {
            setValueIns(valueIns.value);
        }
        setPageIns(1);
    };


    const handleInputChangeIns = (typedIns) => {
        logValueIns(typedIns);
        if (!typedIns) setPageIns(1);
    };

    const handleMenuScrollToBottomIns = () => {
        if (pageIns < totalPagesIns) {
            addOptionsIns();
        }
    };
    const [pageIns, setPageIns] = useState(1);
    const [typedIns, setTypedIns] = useState("");
    const [optionsIns, setOptionsIns] = useState([]);
    const [totalPagesIns, setTotalPagesIns] = useState(0);
      const [sync, setSync] = useState(false);
    
    const logValueIns = debounce((typedIns) => {
        setTypedIns(typedIns);
    }, 250);

    const renderOptionIns = ({
        focusedOption,
        focusOption,
        key,
        labelKey,
        option,
        selectValue,
        style,
        valueArray,
    }) => {
        // Your rendering logic here
    };

    useEffect(() => {
        if (typedIns) {
            addOptionsIns();
        }
    }, [typedIns]);
    const [checkCurrent, setCheckCurrent] = useState('')

    const CheckCurrentEducationStatus = async (Id) => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
        };
        try {
            await axios
                .post(`ResumeData/CheckCurrentRsmEducationStatus`, responseData)
                .then((res) => {
                    setCheckCurrent(res?.data?.responseData)
                });
        } catch (error) {
            console.log(error.response.data.message);
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    // useEffect(() => {
    //     if (showEducationUpdate) {
    //         CheckCurrentEducationStatus()
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [showEducationUpdate]);

    useEffect(() => {
        if (educationData) {
             setShowInputInsteadOfDropdown(true);
            setShowInputInsteadOfDropdownD(true);
            setShowInputInsteadOfDropdownG(true);
            setShowInputInsteadOfDropdownA(true);
            setTypedIns(educationData?.institutionName)
            setValueIns(educationData?.institutionUid)
            setSpecId(educationData?.specilizationId)
            setQualiId(educationData?.qualificationId)
            setCityId(educationData?.cityId);
            setCitySearch(educationData?.cityName)
            setField(educationData?.field)
            setDegree(educationData?.degree)
            setGrade(educationData?.grade)
             if (educationData?.activities) {
                const splitActivities = educationData.activities
                .split(',')
                .map((item) => item?.trim()) // trim spaces
                .filter(Boolean) // remove empty strings
                .map((item) => ({ label: item, value: item }));

                setActivities(splitActivities); // set as array of {label, value}
            }
            // setActivities(educationData?.activities)
            setDescription(educationData?.description)
            setStartDate(educationData?.startYear)
            setEndDate(educationData?.endYear)
            setPresent(educationData?.isPresent)
            // if (educationData.startMonth && educationData.startYear) {
            //     setStartDate(new Date(educationData.startYear, educationData.startMonth - 1));
            // } else {
            //     setStartDate(null);
            // }

            // if (educationData.endMonth && educationData.endYear) {
            //     setEndDate(new Date(educationData.endYear, educationData.endMonth - 1));
            // } else {
            //     setEndDate(null);
            // }
        }
    }, [educationData]);
    const preventYearScroll = (datePickerInstance) => {
        const yearElement = datePickerInstance.currentYearElement;
        if (yearElement) {
            yearElement.addEventListener("wheel", (e) => {
                e.preventDefault(); // Stops mouse scroll
            });
        }
    };

    const [showTooltip, setShowTooltip] = useState(false);
    const [OrganizationName, setOrganizationName] = useState("");
    const [InsName, setInsName] = useState("");

    const targetRef = useRef(null);
    const toggleTooltip = () => {
        setShowTooltip((prev) => !prev);
    };

    const handleCloseNewOrg = (e) => {
        e?.preventDefault?.();
        setInsName("");
        setOrganizationName("");
        setGenOrgInstId("");
        setnewOrgType(null);
        setValueIns(null);
        setFileName("");
    };

    const [fileName, setFileName] = useState(""); // State to store selected filename
    const handleFileChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setFileName(file.name); // Set the filename in state
        }
    };


    const [newOrgType, setnewOrgType] = useState(null);
    const [orgCity, setOrgCity] = useState(null);
    const handleSaveInstitution = async () => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            gnrlOrgName: OrganizationName,
            type: 2,
            cityId: cityId,
            logoImage: fileName,
            locationId: null,
            langKey: language === "en" ? "" : language,
        }

        try {
            const res = await axios.post("/General/AddGeneralOrgByUser", data);
            setGenOrgInstId(res.data.responseData.id);
            setnewOrgType(res.data.responseData.value);
            setInsName(res.data.responseData.value);
            // toast.success(res.data.message);
            setShowTooltip(false);
            setOrganizationName("");
            setOrgCity(null);
            setFileName("");
        } catch (error) {
            if (error.response && error.response.status === 404) {
                // toast.warning(error.response.data.message);
            } else {
                // toast.error(error.response?.data?.message || "An error occurred");
            }
        }
    };


    const reset = () => {
        setTypedIns("")
        setValueIns(null)
        setSpecId(null)
        setQualiId(null)
        setCityId(null);
        setCitySearch('')
        setField('')
        setDegree('')
        setGrade('')
        setActivities('')
        setDescription('')
        setStartDate(null)
        setEndDate(null)
        setPresent(false)
        setPageIns(0)
    }

    useEffect(() => {
        if (
            startDate &&
            endDate &&
            moment(endDate).isBefore(moment(startDate), "day")
        ) {
            setEndDate(null);
        }
    }, [startDate, endDate]);

       //************************education feild Start  ************************// 
    const [isLoading, setIsLoading] = useState(false);
    const [pageF, setPageF] = useState(0);
    const [typedprofile, setTypedprofile] = useState(""); 
    const [optionsF, setOptionsF] = useState([]);
    const [totalPagesField, settotalPagesField] = useState(0);
    
  
    const logValue1 = debounce((typedprofile) => {
      setTypedprofile(typedprofile);
    }, 250);
  
     const addOptionsField = () => {
      setIsLoading(true);
       const data = {
          pageNumber: pageF + 1,
          pageSize: 10,
           deviceType: "Web",
      langKey: language === "en" ? "" : language,
       }
      axios
        .post(
          `Master/GetEducationInfoDDL?InfoType=Field&search=${typedprofile}`, data
        )
        .then((response) => {
          console.log("response333333333",response );
          const data = response?.data?.responseData?.allData;
          // Check if data is an array
          if (Array.isArray(data)) {
            const mappedData = data.map((item,index) => ({
              label: item,
              value: item,
            }));
            console.log("mappedData==>",mappedData)
            setOptionsF((prevOptions) => [...prevOptions, ...mappedData]);
          } else {
            console.error("Expected data to be an array, but got:", data);
          }
  
          setPageF((prevPage) => prevPage + 1);
          setIsLoading(false);
          settotalPagesField(response?.data?.paging?.totalPages || 0);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
          setIsLoading(false);
        });
    }; 
    const handleOpenField = () => {
      setPageF(1);
    };
  
    const handleChangeField = (value) => {
      if (value === null) { 
        setField(null);
      } else {
        setField(value.label);
      } 
    };
  
    const handleInputChangeField = (typedprofile) => {
      logValue1(typedprofile);
      if (!typedprofile) setPageF(0);
    };
  
    const handleMenuScrollToBottomField = () => {
      if (pageF < totalPagesField) {
        addOptionsField();
      }
    };
  
    useEffect(() => {
      if (typedprofile) {
      addOptionsField();
      }
    }, [typedprofile]);
  
    //************************ education feild End  ************************//
  
   //************************education degree Start  ************************//  
    const [pageD, setPageD] = useState(0);
    const [typedDegree, setTypeddegree] = useState(""); 
    const [optionsD, setOptionsD] = useState([]);
    const [totalPagesDegree, settotalPagesDegree] = useState(0);
    
  
    const logValueD = debounce((typedDegree) => {
      setTypeddegree(typedDegree);
    }, 250);
  
     const addOptionsDegree = () => {
      setIsLoading(true);
       const data = {
          pageNumber: pageD + 1,
          pageSize: 100,
           deviceType: "Web",
      langKey: language === "en" ? "" : language,
       }
      axios
        .post(
          `Master/GetEducationInfoDDL?InfoType=Degree&search=${typedDegree}`, data
        )
        .then((response) => {
          console.log("responsedddddddddddddddd",response );
          const data = response?.data?.responseData?.allData;
          // Check if data is an array
          if (Array.isArray(data)) {
            const mappedData = data.map((item,index) => ({
              label: item,
              value: item,
            }));
            console.log("mappedData==>",mappedData)
            setOptionsD((prevOptions) => [...prevOptions, ...mappedData]);
          } else {
            console.error("Expected data to be an array, but got:", data);
          }
  
          setPageD((prevPage) => prevPage + 1);
          setIsLoading(false);
          settotalPagesDegree(response?.data?.paging?.totalPages || 0);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
          setIsLoading(false);
        });
    }; 
    const handleOpenDegree = () => {
      setPageD(1);
    };
  
    const handleChangeDegree = (value) => {
      if (value === null) { 
        setDegree(null);
      } else {
        setDegree(value.label);
      } 
    };
  
    const handleInputChangeDegree = (typedDegree) => {
      logValueD(typedDegree);
      if (!typedDegree) setPageD(0);
    };
  
    const handleMenuScrollToBottomDegree = () => {
      if (pageD < totalPagesDegree) {
        addOptionsDegree();
      }
    };
  
    useEffect(() => {
      if (typedDegree) {
      addOptionsDegree();
      }
    }, [typedDegree]);
  
    //************************ education degree End  ************************//
   //************************education degree Start  ************************// 
    const [pageG, setPageG] = useState(0);
    const [typedGrade, setTypedGrade] = useState("");
    const [optionsG, setOptionsG] = useState([]);
    const [totalPagesGrade, setTotalPagesGrade] = useState(0);

  
    const logValueG = debounce((typedGrade) => {
      setTypedGrade(typedGrade);
    }, 250);
  
     const addOptionsGrade = () => {
      setIsLoading(true);
       const data = {
          pageNumber: pageG + 1,
          pageSize: 100,
           deviceType: "Web",
      langKey: language === "en" ? "" : language,
       }
      axios
        .post(
          `Master/GetEducationInfoDDL?InfoType=Grade&search=${typedGrade}`, data
        )
        .then((response) => {
          console.log("responsedddddddddddddddd",response );
          const data = response?.data?.responseData?.allData;
          // Check if data is an array
          if (Array.isArray(data)) {
            const mappedData = data.map((item,index) => ({
              label: item,
              value: item,
            }));
            console.log("mappedData==>",mappedData)
            setOptionsG((prevOptions) => [...prevOptions, ...mappedData]);
          } else {
            console.error("Expected data to be an array, but got:", data);
          }
  
          setPageG((prevPage) => prevPage + 1);
          setIsLoading(false);
          setTotalPagesGrade(response?.data?.paging?.totalPages || 0);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
          setIsLoading(false);
        });
    }; 
    const handleOpenGrade = () => {
      setPageG(1);
    };
  
    const handleChangeGrade = (value) => {
      if (value === null) { 
        setGrade(null);
      } else {
        setGrade(value.label);
      } 
    };
  
    const handleInputChangeGrade = (typedGrade) => {
      logValueG(typedGrade);
      if (!typedGrade) setPageG(0);
    };
  
    const handleMenuScrollToBottomGrade = () => {
      if (pageG < totalPagesGrade) {
        addOptionsGrade();
      }
    };
  
    useEffect(() => {
      if (typedGrade) {
      addOptionsGrade();
      }
    }, [typedGrade]);
  
    //************************ education degree End  ************************//
  
     //************************education activity Start  ************************// 

    const [pageA, setPageA] = useState(0);
    const [typedActivities, setTypedActivities] = useState("");
    const [optionsA, setOptionsA] = useState([]);
    const [totalPagesActivities, setTotalPagesActivities] = useState(0);

  
    const logValueA = debounce((typedActivities) => {
      setTypedActivities(typedActivities);
    }, 250);
  
     const addOptionsActivity = () => {
      setIsLoading(true);
       const data = {
          pageNumber: pageA + 1,
          pageSize: 100,
           deviceType: "Web",
      langKey: language === "en" ? "" : language,
       }
      axios
        .post(
          `Master/GetEducationInfoDDL?InfoType=Activities&search=${typedActivities}`, data
        )
        .then((response) => {
          console.log("responsedddddddddddddddd",response );
          const data = response?.data?.responseData?.allData;
          // Check if data is an array
          if (Array.isArray(data)) {
            const mappedData = data.map((item,index) => ({
              label: item,
              value: item,
            }));
            console.log("mappedData==>",mappedData)
            setOptionsA((prevOptions) => [...prevOptions, ...mappedData]);
          } else {
            console.error("Expected data to be an array, but got:", data);
          }
  
          setPageA((prevPage) => prevPage + 1);
          setIsLoading(false);
          setTotalPagesActivities(response?.data?.paging?.totalPages || 0);
        })
        .catch((error) => {
          console.error("Error fetching options:", error);
          setIsLoading(false);
        });
    }; 
    const handleOpenActivity = () => {
      setPageA(1);
    };
  
    const handleChangeActivity = (value) => {
      // if (value === null) { 
      //   setActivities(null);
      // } else {
        setActivities(value || []);
      // } 
    };
  
    const handleInputChangeActivity = (typedActivities) => {
      logValueA(typedActivities);
      if (!typedActivities) setPageA(0);
    };
  
    const handleMenuScrollToBottomActivity = () => {
      if (pageA < totalPagesActivities) {
        addOptionsActivity();
      }
    };
  
    useEffect(() => {
      if (typedActivities) {
      addOptionsActivity();
      }
    }, [typedActivities]);
  
    //************************ education activity End  ************************//
  
  //     useEffect(() => {
  //   let scrollY = 0;
  
  //   if (showEducationUpdate) {
  //     scrollY = window.scrollY;
  
  //     // Lock scroll
  //     document.body.style.position = 'fixed';
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.left = '0';
  //     document.body.style.right = '0';
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden'; // 🛠️ Add this line
  //     document.body.classList.add('modal-open');
  //   } else {
  //     // Unlock scroll
  //     const scrollYValue = document.body.style.top;
  //     document.body.style.position = '';
  //     document.body.style.top = '';
  //     document.body.style.left = '';
  //     document.body.style.right = '';
  //     document.body.style.overflow = '';
  //     document.documentElement.style.overflow = ''; // 🛠️ Add this line
  //     document.body.classList.remove('modal-open');
  
  //     window.scrollTo(0, parseInt(scrollYValue || '0') * -1);
  //   }
  // }, [showEducationUpdate]);

  useEffect(() => {
  let scrollY = 0;

  if (showEducationUpdate) {
    // Save current scroll position
    scrollY = window.scrollY;
    document.body.dataset.scrollY = scrollY; // store in dataset

    // Lock scrolling
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('modal-open');
  } else {
    // Unlock scrolling
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('modal-open');

    // Restore scroll position
    const storedY = document.body.dataset.scrollY || "0";
    window.scrollTo(0, parseInt(storedY, 10));
  }
}, [showEducationUpdate]);

const modalContentRef = useRef(null); 

    return (
        <>
            {showEducationUpdate && (
                <div className="profile-education-cont">
                    <div
                        className="modal fade show modal-lg"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "block" }}
                    >
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content" ref={modalContentRef}>
                                <div className="setting-header d-flex justify-content-between align-items-center">
                                    <h6>{t("User Profile.Update Education")}</h6>
                                      <CloseSharpIcon
                                        className="material-symbols-sharp me-3 pointer"
                                        onClick={() => {
                                            handleUpdateEducationClose()
                                            reset()
                                        }}
                                    />
                                </div>
                                <Form>
                                    <div className="row modal-p settings CreateCompany">
                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about" for="institute">
                                            </label>{t("User Profile.Institution")}
                                                <span className="text-danger ms-2">*</span>
                                            {InsName !== "" ? (
                                                <a
                                                    href="#"
                                                    onClick={handleCloseNewOrg}
                                                    className="createModal f-14 ms-2"
                                                >
                                                    {t("User Profile.Close")}
                                                </a>
                                            ) : (
                                            <a
                                                href="#"
                                                ref={targetRef}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleTooltip();
                                                }}
                                                className="createModal f-14 ms-2"
                                            >
                                                {t("User Profile.Create New")}
                                            </a>
                                            )}
                                            <Overlay
                                                target={targetRef.current}
                                                show={showTooltip}
                                                placement="bottom"
                                                rootClose
                                                container={document.querySelector(".modal")}
                                                onHide={() => setShowTooltip(false)} // Close when clicking outside
                                            >
                                                <Popover id="popover-basic">
                                                    <Popover.Header as="h3" className="Dark-Body-Card-group">{t("User Profile.Create Institute")}</Popover.Header>
                                                    <Popover.Body className="Dark-Body-Card-group">
                                                        <Form>
                                                            <div>
                                                                <label className="mb-1 Text-mb-Create">{t("User Profile.Institute name")}</label>
                                                                <input
                                                                    type="text"
                                                                    value={OrganizationName}
                                                                    onChange={(e) => setOrganizationName(e.target.value)}
                                                                    placeholder={t("User Profile.Enter Institute name")}
                                                                    className="mb-2 form-control Dark-Input-from-group"
                                                                />
                                                            </div>
                                                            <div>
                                                                <label className="mb-1 Text-mb-Create">{t("User Profile.City")}</label>
                                                                <Select
                                                                    defaultValue={cityId}
                                                                    onChange={(selectedOption) =>
                                                                        setCityId(selectedOption.value)
                                                                    }
                                                                    options={cityData}
                                                                    placeholder={t("modals.Search and Select City")}
                                                                    onInputChange={(inputValue) => {
                                                                        setCitySearch(inputValue);

                                                                    }}
                                                                    invalid={display && cityId === ""}
                                                                    styles={customStyles}
                                                                />
                                                            </div>
                                                            <div className=" mt-2 mb-2 Text-mb-Create">
                                                                <label className="mb-1">{t("User Profile.Institute logo")}</label>
                                                                <input
                                                                    type="file"
                                                                    id="lastName"
                                                                    // className="form-control Dark-Input-from-group"
                                                                    placeholder=""
                                                                    onChange={handleFileChange}
                                                                //   onChange={(e) => {
                                                                //     handleProfileImageChange(e);
                                                                //   }}
                                                                //   invalid={displays && profileImage === ""}
                                                                />
                                                                {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                                                            </div>
                                                            <div className="d-flex justify-content-end">
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm"
                                                                    onClick={handleSaveInstitution}
                                                                    className="me-2"
                                                                >
                                                                    {t("Newsfeed.Save")}
                                                                </Button>
                                                                <Button
                                                                    variant="secondary"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        setShowTooltip(false);
                                                                        setOrganizationName("");
                                                                    }}
                                                                >
                                                                    {t("Connections.Cancel")}
                                                                </Button>
                                                            </div>
                                                        </Form>
                                                    </Popover.Body>
                                                </Popover>
                                            </Overlay>
                                            {InsName !== "" ? (
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        value={InsName}
                                                        placeholder={t("User Profile.Enter Institute name")}
                                                        className="mb-2 form-control"
                                                        disabled
                                                    />
                                                    <CloseSharpIcon
                                                        className="material-symbols-sharp pointer ms-2 mb-2"
                                                        onClick={handleCloseNewOrg}
                                                        title={t("User Profile.Close")}
                                                    />
                                                </div>
                                            ) : (
                                            <Select
                                                value={optionsIns.find((option) => option.value === valueIns)}
                                                options={optionsIns}
                                                styles={customStyles}
                                                optionRenderer={renderOptionIns}
                                                onOpen={handleOpenIns}
                                                onChange={handleChangeIns}
                                                onMenuScrollToBottom={handleMenuScrollToBottomIns}
                                                onInputChange={handleInputChangeIns}
                                                isClearable
                                                className="iconsDropdown"
                                                invalid={display && valueIns === ""}
                                                placeholder={t("User Profile.Search and Select Institution")}
                                                formatOptionLabel={(option) => (
                                                    <div>
                                                        {option.label}
                                                        {option.isOrgVrfd === true ? (
                                                            <img src={resume.verified} width={15} className="ms-1" />
                                                        ) : option.isOrgRgd === true ? (
                                                            <img src={resume.register} width={15} className="ms-1" />
                                                        ) : (
                                                            <img src={resume.unregister} width={15} className="ms-1" />
                                                        )}
                                                    </div>
                                                )}
                                            />
                                            )}
                                            {display && !valueIns && !getOrgInsTId ? (
                                                <span className="error_msg_lbl">
                                                    {t("User Profile.Please Select Institution")}{" "}
                                                </span>
                                            ) : null}
                                        </div>



                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.City")}<span className="text-danger ms-2">*</span>
                                            </label>
                                            <Select
                                                value={cityData.find((option) => option.value === cityId)}
                                                onChange={(selectedOption) =>
                                                    selectedOption === null ? setCityId(null) : setCityId(selectedOption.value)

                                                }
                                                options={cityData}
                                                placeholder={t("modals.Search and Select City")}
                                                onInputChange={(inputValue) => {
                                                    setCitySearch(inputValue);
                                                }}
                                                invalid={display && citySearch === ""}
                                                styles={customStyles}
                                                isClearable
                                            />
                                            {display && !citySearch ? (
                                                <span className="error_msg_lbl">{t("User Profile.Select City")} </span>
                                            ) : null}
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.Field")}<span className="text-danger ms-2">*</span>
                                            </label>
                                    {showInputInsteadOfDropdown ? (
                                        <input
                                          type="text"
                                          className="Dark-Input-from-group"
                                          value={field}
                                          onChange={(e) => setField(e.target.value)}
                                          onBlur={() => {
                                            if (field?.trim()) {
                                              setShowInputInsteadOfDropdown(false);
                                            }
                                          }}
                                          autoFocus
                                          isInvalid={display && field === ""}
                                        />
                                      ) : (
                                        <CreatableSelect
                                          options={optionsF}
                                          styles={customStyles}
                                          placeholder={t("User Profile.Search and Select Field")}
                                          onOpen={handleOpenField}
                                          onChange={(selectedOption) => {
                                            if (selectedOption) {
                                              setField(selectedOption.value);
                                              setShowInputInsteadOfDropdown(true); // switch to editable input
                                            } else {
                                              setField("");
                                            }
                                          }}
                                          onMenuScrollToBottom={handleMenuScrollToBottomField}
                                          onInputChange={handleInputChangeField}
                                          isClearable
                                          isValidNewOption={(inputValue, _, selectOptions) =>
                                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                          }
                                          onCreateOption={(inputValue) => {
                                            const newOption = { label: inputValue, value: inputValue };
                                            setOptionsF((prev) => [...prev, newOption]);
                                            setField(inputValue);
                                            setShowInputInsteadOfDropdown(true); // switch to input after create
                                          }}
                                          value={field ? { label: field, value: field } : null}
                                          className={display && field === "" ? "is-invalid" : ""}
                                        />
                                      )}                                          
                                             {/* <CreatableSelect
                                          defaultValue={field}
                                          options={optionsF}
                                          styles={customStyles}
                                        //   optionRenderer={renderOption}
                                          placeholder={"Search and Select Field"}
                                          onOpen={handleOpenField}
                                          onChange={handleChangeField}
                                          onMenuScrollToBottom={handleMenuScrollToBottomField}
                                          onInputChange={handleInputChangeField}
                                          isClearable
                                          isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                          }
                                          onCreateOption={(inputValue) => {
                                            const newOption = { label: inputValue, value: inputValue };
                                            setOptionsF((prev) => [...prev, newOption]);
                                            setField(inputValue); // directly set the value
                                          }}
                                          value={field ? { label: field, value: field } : null}
                                         
                                          invalid={display && field === ""}
                                        /> */}
                                            {display && !field ? (
                                                <span className="error_msg_lbl">{t("User Profile.Enter Field")} </span>
                                            ) : null}
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.Degree")}<span className="text-danger ms-2">*</span>
                                            </label>
                                             
                           {showInputInsteadOfDropdownD ? (
                              <input
                                type="text"
                                className="Dark-Input-from-group"
                                value={degree}
                                onChange={(e) => setDegree(e.target.value)}
                                onBlur={() => {
                                  if (degree?.trim()) {
                                    setShowInputInsteadOfDropdownD(false);
                                  }
                                }}
                                autoFocus
                                isInvalid={display && degree === ""}
                              />
                                    ) : (
                                      <CreatableSelect
                                        options={optionsD}
                                        styles={customStyles}
                                        placeholder={t("User Profile.Search and Select Degree")}
                                        onOpen={handleOpenDegree}
                                        onChange={(selectedOption) => {
                                          if (selectedOption) {
                                            setDegree(selectedOption.value);
                                            setShowInputInsteadOfDropdownD(true); // switch to editable input
                                          } else {
                                            setDegree("");
                                          }
                                        }}
                                        onMenuScrollToBottom={handleMenuScrollToBottomDegree}
                                        onInputChange={handleInputChangeDegree}
                                        isClearable
                                        isValidNewOption={(inputValue, _, selectOptions) =>
                                          !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                        }
                                        onCreateOption={(inputValue) => {
                                          const newOption = { label: inputValue, value: inputValue };
                                          setOptionsD((prev) => [...prev, newOption]);
                                          setDegree(inputValue);
                                          setShowInputInsteadOfDropdownD(true); // switch to input after create
                                        }}
                                        value={degree ? { label: degree, value: degree } : null}
                                        className={display && degree === "" ? "is-invalid" : ""}
                                      />
                                    )}                                        
                                              {/* <CreatableSelect
                                          defaultValue={degree}
                                          options={optionsD}
                                          styles={customStyles}
                                        //   optionRenderer={renderOption}
                                          placeholder={"Search and Select Degree"}
                                          onOpen={handleOpenDegree}
                                          onChange={handleChangeDegree}
                                          onMenuScrollToBottom={handleMenuScrollToBottomDegree}
                                          onInputChange={handleInputChangeDegree}
                                          isClearable
                                           isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                          }
                                          onCreateOption={(inputValue) => {
                                            const newOption = { label: inputValue, value: inputValue };
                                            setOptionsD((prev) => [...prev, newOption]);
                                            setDegree(inputValue); // directly set the value
                                          }}
                                          value={degree ? { label: degree, value: degree } : null}
                          
                                          invalid={display && degree === ""}
                                        /> */}
                                            {display && !degree ? (
                                                <span className="error_msg_lbl">{t("User Profile.Enter Degree")} </span>
                                            ) : null}
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.Grade")}
                                            </label>
                                           {showInputInsteadOfDropdownG ? (
                                                    <input
                                                      type="text"
                                                      className="Dark-Input-from-group"
                                                      value={grade}
                                                      onChange={(e) => setGrade(e.target.value)}
                                                      onBlur={() => {
                                                        if (grade?.trim()) {
                                                          setShowInputInsteadOfDropdownG(false);
                                                        }
                                                      }}
                                                      autoFocus
                                                      isInvalid={display && grade === ""}
                                                    />
                                                  ) : (
                                                    <CreatableSelect
                                                      options={optionsG}
                                                      styles={customStyles}
                                                      placeholder={t("User Profile.Search and Select Grade")}
                                                      onOpen={handleOpenGrade}
                                                      onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                          setGrade(selectedOption.value);
                                                          setShowInputInsteadOfDropdownG(true); // switch to editable input
                                                        } else {
                                                          setGrade("");
                                                        }
                                                      }}
                                                      onMenuScrollToBottom={handleMenuScrollToBottomGrade}
                                                      onInputChange={handleInputChangeGrade}
                                                      isClearable
                                                      isValidNewOption={(inputValue, _, selectOptions) =>
                                                        !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                                      }
                                                      onCreateOption={(inputValue) => {
                                                        const newOption = { label: inputValue, value: inputValue };
                                                        setOptionsG((prev) => [...prev, newOption]);
                                                        setGrade(inputValue);
                                                        setShowInputInsteadOfDropdownG(true); // switch to input after create
                                                      }}
                                                      value={grade ? { label: grade, value: grade } : null}
                                                      className={display && grade === "" ? "is-invalid" : ""}
                                                    />
                                                  )}                                         
                                             {/* <CreatableSelect
                                          defaultValue={grade}
                                          options={optionsG}
                                          styles={customStyles}
                                        //   optionRenderer={renderOption}
                                          placeholder={"Search and Select Grade"}
                                          onOpen={handleOpenGrade}
                                          onChange={handleChangeGrade}
                                          onMenuScrollToBottom={handleMenuScrollToBottomGrade}
                                          onInputChange={handleInputChangeGrade}
                                          isClearable
                                           isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                            !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                          }
                                          onCreateOption={(inputValue) => {
                                            const newOption = { label: inputValue, value: inputValue };
                                            setOptionsG((prev) => [...prev, newOption]);
                                            setGrade(inputValue); // directly set the value
                                          }}
                                          value={grade ? { label: grade, value: grade } : null}
                          
                                          invalid={display && grade === ""}
                                        /> */}
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.Activities")}
                                            </label>
                                            {/* <Input
                                                type="text"
                                                value={activities}
                                                onChange={(e) => setActivities(e.target.value)}
                                            /> */}
                                             {/* <Select
                                          defaultValue={activities}
                                          options={optionsA}
                                          styles={customStyles}
                                        //   optionRenderer={renderOption}
                                          placeholder={"Search and Select Activity"}
                                          onOpen={handleOpenActivity}
                                          onChange={handleChangeActivity}
                                          onMenuScrollToBottom={handleMenuScrollToBottomActivity}
                                          onInputChange={handleInputChangeActivity}
                                          isClearable
                                          isMulti
                                          invalid={display && activities === ""}
                                        /> */}
                                           <CreatableSelect
                                            options={optionsA}
                                            styles={customStyles}
                                            placeholder={t("modals.Search and Select Activity")}
                                            onMenuOpen={handleOpenActivity}
                                            onChange={handleChangeActivity}
                                            onMenuScrollToBottom={handleMenuScrollToBottomActivity}
                                            onInputChange={handleInputChangeActivity}
                                            isClearable
                                            isMulti
                                            value={Array.isArray(activities) ? activities : []}
                                            isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                                !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                            }
                                            onCreateOption={(inputValue) => {
                                                const newOption = { label: inputValue, value: inputValue };
                                                setOptionsA((prev) => [...prev, newOption]);
                                                setActivities((prev) => [...(prev || []), newOption]); // add to existing array
                                            }}
                                            invalid={display && (!activities || activities.length === 0)}
                                            />
                                        </div>

                                        {present === true || checkCurrent === false ? <div className="col-md-12 mt-2 d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                //   id={`check-${item.id}`}
                                                //   checked={selectedWorkLevelList.includes(item.id)}
                                                checked={present}
                                                onChange={() => setPresent(!present)}
                                            />
                                            <label htmlFor="about">{t("User Profile.IsPresent")}</label>
                                        </div> : ''}


                                        <div className="col-md-6 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.Start Year")}<span className="text-danger ms-2">*</span>
                                            </label>

                                            <Flatpickr className='form-control' value={startDate} onChange={date => setStartDate(date[0] || null)} id='dob' options={{
                                                maxDate: "today", // Disables future dates
                                                appendTo: modalContentRef.current || undefined,
                                                onReady: (selectedDates, dateStr, instance) => {
                                                    preventYearScroll(instance); // Call the function to stop scroll on year
                                                },
                                                onOpen: (selectedDates, dateStr, instance) => {
                                                    preventYearScroll(instance); // Also prevent scroll when the picker opens
                                                },
                                            }} />
                                            {display && !startDate ? (
                                                <span className="error_msg_lbl">
                                                    {t("User Profile.Please Select Start Year")}{" "}
                                                </span>
                                            ) : null}
                                        </div>
                                        {present === true ? '' :
                                            <div className="col-md-6 mt-2">
                                                <label htmlFor="about">
                                                    {t("User Profile.End Year")}<span className="text-danger ms-2">*</span>
                                                </label>

                                                <Flatpickr className='form-control' value={endDate} onChange={date => setEndDate(date[0] || null)} id='dob' options={{
                                                    minDate: startDate || undefined,
                                                    appendTo: modalContentRef.current || undefined,
                                                    onReady: (selectedDates, dateStr, instance) => {
                                                        preventYearScroll(instance); // Call the function to stop scroll on year
                                                    },
                                                    onOpen: (selectedDates, dateStr, instance) => {
                                                        preventYearScroll(instance); // Also prevent scroll when the picker opens
                                                    },
                                                }} />
                                                {display && !endDate ? (
                                                    <span className="error_msg_lbl">
                                                        {t("User Profile.Please Select End Year")}{" "}
                                                    </span>
                                                ) : null}
                                                {!present && isEducationDateRangeInvalid ? (
                                                    <span className="error_msg_lbl">
                                                        End date cannot be earlier than start date.
                                                    </span>
                                                ) : null}
                                            </div>}

                                        <div className="col-md-12 mt-2">
                                            <label htmlFor="about">
                                                {t("User Profile.Description")}
                                            </label>
                                            <textarea
                                                id="about"
                                                name="about"
                                                rows="4"
                                                cols="50"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                            ></textarea>
                                        </div>

                                        <div className="text-end mt-4 updateBtn">
                                             {/* {userData?.userConfig?.hasDob && userData?.userConfig?.hasGender 
                                             && userData?.userConfig?.hasCity 
                                             && userData?.userConfig?.hasCcv === true &&
                                              <> */}
                                             <div className="d-flex align-items-center justify-content-end">
                                               
                                               {UserCcv === "Active" && <>
                                                <input
                                                type="checkbox"
                                                style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                onChange={() => setSync(!sync)}
                                                checked={sync}
                                                />
                                                <label htmlFor="about">
                                                {t("User Profile.Sync With Profile")}
                                                </label>
                                                </>}
 
                                              <button
                                                type="button"
                                                className="closebtn me-2 ms-3"
                                                onClick={handleUpdateEducationClose}
                                                style={{ width: "70px" }}
                                            >
                                                {t("User Profile.Close")}
                                            </button>
                                            <button
                                                type="button"
                                                className="mainBtn1"
                                                onClick={UpdateEducation}
                                                style={{ width: "107px" }}
                                            >
                                                {t("Manage Job.Update")}
                                            </button>
                                              </div>

                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    );
};

export default CCVEducationUpdate;
